import { createRoutes } from "common/routes/routes.utils";

import { AddressBookViews } from "@bps/blocks";

import { Permission } from "../../core/common-types/permission.enum";

export const routes = {
  appointmentBooking: createRoutes({
    basePath: { path: "/booking/*", text: "Booking" },
    locationEdit: {
      title: "Booking - Online configuration",
      path: "/booking/practice-profile",
      text: "Online configuration"
    },
    onlineSettings: {
      title: "Booking - Online settings",
      path: "/booking/online-settings",
      text: "Online settings"
    }
  }),
  bpMobile: {
    text: "Mobile",
    path: "/mobile",
    permissions: Permission.ProsBpmWebAllowed
  },
  bpMobileBooking: createRoutes({
    appointments: {
      title: "Mobile - Appointments",
      text: "Appointments",
      path: "/mobile/appointments",
      permissions: Permission.ProsBpmWebAllowed
    },
    bookingCalendar: {
      title: "Mobile - Booking calendar",
      text: "Booking calendar",
      path: "/mobile/booking-calendar",
      permissions: Permission.ProsBpmWebAllowed
    }
  }),
  bpMobileClinicalRecord: createRoutes({
    basePath: {
      text: "Clinical record",
      path: "/mobile/clinical-record",
      permissions: Permission.ProsBpmWebAllowed
    },
    view: {
      title: "Mobile - Patient record",
      text: "Patient record",
      path: "/mobile/clinical-record/:id",
      permissions: Permission.ProsBpmWebAllowed
    },
    edit: {
      title: "Mobile - Clinical record",
      text: "Clinical record",
      path: "/mobile/clinical-record/patient/:patientId/:encounterId/:appointmentId?",
      permissions: [Permission.ProsBpmWebAllowed, Permission.BpmConsultAllowed],
      permissionsOperator: "and"
    }
  }),
  bpMobileAddressBook: createRoutes({
    basePath: {
      text: "Address book",
      path: "/mobile/address-book/",
      permissions: Permission.ProsBpmWebAllowed
    },
    patients: {
      title: "Mobile - Patients",
      text: "Patients",
      path: `/mobile/address-book/${AddressBookViews.Patients}`,
      permissions: Permission.ProsBpmWebAllowed
    }
  }),
  bpMobileTodo: createRoutes({
    userInbox: {
      title: "Mobile - Inbox",
      text: "Inbox",
      path: "/mobile/to-do/inbox",
      permissions: Permission.ProsBpmWebAllowed
    }
  }),
  bpMobileDocumentEditor: createRoutes({
    basePath: {
      text: "document editor",
      path: "/mobile/document-editor",
      permissions: Permission.ProsBpmWebAllowed
    },
    edit: {
      title: "Mobile - Document editor",
      text: "document editor",
      path: "/mobile/document-editor/:id",
      permissions: Permission.ProsBpmWebAllowed
    }
  }),
  bpMobileDashboard: createRoutes({
    basePath: {
      title: "Mobile - Dashboard",
      text: "Dashboard",
      path: "/mobile",
      permissions: Permission.ProsBpmWebAllowed
    }
  }),
  settings: createRoutes({
    basePath: {
      text: "Settings",
      path: "/settings/*",
      customPermissionsCheck: userPermissions => {
        return (
          userPermissions.includes(Permission.ProsOnlineSettingsAllowed) &&
          userPermissions.some(p =>
            [
              Permission.PerPltLicenceRead,
              Permission.PerPltLicenceWrite,
              Permission.PerPltUserRead,
              Permission.PerPltUserWrite,
              Permission.PerPltNetworkRead,
              Permission.PerPltNetworkWrite,
              Permission.BHB_WRITE,
              Permission.BHB_READ
            ].includes(p)
          )
        );
      }
    },
    home: {
      title: "Settings - Home",
      text: "Home",
      path: "/settings/home"
    },
    networkAndSecurity: {
      title: "Settings - Network and security",
      text: "Network and security",
      path: "/settings/network-and-security"
    },
    mobileLicences: {
      title: "Settings - Mobile",
      text: "Mobile",
      path: "/settings/:productFamilyCode/licences"
    },
    bestHealthBooking: {
      title: "Settings - Best Health Booking",
      text: "Best Health Booking",
      path: "/settings/bhb/*"
    }
  })
};
